import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    backgroundColor: "white",
    height: "70vh",
    width: "80vw",
  },
  doneButton: {
    alignItems: "flex-end",
  },
  doneText: {
    flex: 1,
    paddingTop: 10,
    paddingRight: 10,
    color: "$question_text",
    fontSize: "1.3rem",
    fontWeight: "bold",
    marginVertical: 5,
    marginHorizontal: 10,
  },
  text: {
    flexGrow: 1,
    width: "95%",
    fontSize: "1.5rem",
    alignSelf: "center",
  },
});
